module.exports = __webpack_public_path__ + "img/preview-lg.7538f870.png";